import React from 'react';
import { ButtonNew } from '@components-library/ButtonNew/ButtonNew';
import { MoreHorizontalIcon } from '@components-library/Icons/iconsComponents';
import { Table, VisibilityState } from '@tanstack/react-table';
import { Popover } from 'antd';
import cn from 'classnames';
import { DropdownInner } from './GridVisibilityDropdownInner';
import styles from './gridVisibilityDropdown.module.scss';

export interface IGridVisibilityDropdownProps {
  className?: string;
  columnVisibility: VisibilityState;
  columnOrder: string[];
  setColumnOrder: (newOrder: string[]) => void;
  table: Table<unknown>;
}

export const GridVisibilityDropdown = ({
  columnVisibility,
  columnOrder,
  setColumnOrder,
  table,
  className,
}: IGridVisibilityDropdownProps) => {
  return (
    <Popover
      placement="leftTop"
      rootClassName={styles.popoverRoot}
      content={
        <div className={styles.popoverInner}>
          <DropdownInner
            table={table}
            columnVisibility={columnVisibility}
            columnOrder={columnOrder}
            setColumnOrder={setColumnOrder}
          />
        </div>
      }
      trigger="click">
      <ButtonNew className={cn(styles.menuButton, className)} size="small" icon={<MoreHorizontalIcon />} />
    </Popover>
  );
};
